import React, { useEffect, useState, useCallback, useRef } from "react";
import { useDispatch, useSelector } from "react-redux";
import { v4 as uuidv4 } from "uuid";
import TableForm from "../../../../components/RoleTableForm"; // Change to Role-based form
import ModalManager from "../../../../components/modalManager";
import { setOpenModal } from "../../../../redux/Actions/UserAction";
import styles from "./role.module.css"; // Rename style file
import Button from "@mui/material/Button"; // Assuming you're using Material UI for the button
import DataTable from "./component/DataTable";
import { useNavigate } from "react-router-dom";
import AddRoleTableForm from "../../../../components/RoundOpening";
import apiCall from "../../../API/apiService";
import apiEndpoints from "../../../API/apiEndpoints";
import { toasty } from "../../../../Helper";
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import DialogActions from '@mui/material/DialogActions';
import CreateRole from "../../../assets/svgComponent/CreateRole.svg";
import { Button as AntButton, Dropdown, Space, Select, Radio } from 'antd';
import { FilterOutlined, CloseOutlined } from '@ant-design/icons';
import cancelIcon from "../../../assets/svgComponent/cancel.svg";
import saveIcon from "../../../assets/svgComponent/save.svg";
import { Pagination, Spin } from 'antd';
import filterIcon from "../../../assets/svgComponent/filter.svg";

const RoleManagement = () => {
	const { modalVisible, modalType } = useSelector((state) => state.user);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [rows, setRows] = React.useState([]);
	const [organizations, setOrganizations] = React.useState([]);
	const [filterOrganization, setFilterOrganization] = React.useState("");
	const [filterVisible, setFilterVisible] = React.useState(false);
	const filterRef = useRef(null);
	const [totalPages, setTotalPages] = useState(0);
	// Add states for filter data loading
	const [filterOrganizations, setFilterOrganizations] = useState([]);
	const [isLoadingFilterOrgs, setIsLoadingFilterOrgs] = useState(false);
	const [isLoadingFilterDepts, setIsLoadingFilterDepts] = useState(false);
	const [isLoadingFilterSubDepts, setIsLoadingFilterSubDepts] = useState(false);
	// Add roleSearch state
	const [roleSearch, setRoleSearch] = useState("");

	const resetItemState = () => {
		return {
			id: "",
			organization_id: "",
			organization_name: "",
			department_id: "",
			department_name: "",
			subdepartment_id: "",
			subdepartment_name: "",
			role_name: "",
			salary_min: "",
			salary_max: "",
			level: "",
			designation: "",
			employment_type: "",
			work_arrangement: "",
			total_rounds: "",
			location_id: "",
		};
	};

	const [newItem, setNewItem] = React.useState(resetItemState());
	const [editingIndex, setEditingIndex] = React.useState(null);
	const [currentPage, setCurrentPage] = React.useState(1);
	const [pageSize, setPageSize] = React.useState(15);
	const [totalItems, setTotalItems] = React.useState(0);
	const [filteredRows, setFilteredRows] = React.useState([]);
	const [isTableLoading, setIsTableLoading] = useState(false);
	const [isLoading, setIsLoading] = React.useState(true);
	const [departments, setDepartments] = React.useState([]);
	const [subDepartments, setSubDepartments] = React.useState([]);
	// States for filtering
	const [filterDepartment, setFilterDepartment] = React.useState("");
	const [filterSubDepartment, setFilterSubDepartment] = React.useState("");
	const [noDataModalOpen, setNoDataModalOpen] = React.useState(false);
	const [isFilterApplied, setIsFilterApplied] = useState(false);
	const [filters, setFilters] = useState({
		organization_id: "",
		department_id: "",
		subdepartment_id: ""
	});
	const [openNoDataDialog, setOpenNoDataDialog] = useState(false);
	const [rowsPerPage, setRowsPerPage] = useState(10);
	const [allRows, setAllRows] = useState([]);
	const [tempFilters, setTempFilters] = useState({
		organization_id: "",
		department_id: "",
		subdepartment_id: ""
	});

	// Add these new state variables
	const [filteredDepartments, setFilteredDepartments] = useState([]);
	const [filteredSubDepartments, setFilteredSubDepartments] = useState([]);
	// Add new state for modal data loading
	const [modalOrganizations, setModalOrganizations] = useState([]);
	const [modalDepartments, setModalDepartments] = useState([]);
	const [modalSubDepartments, setModalSubDepartments] = useState([]);
	const [isLoadingDepartments, setIsLoadingDepartments] = useState(false);
	const [isLoadingSubDepartments, setIsLoadingSubDepartments] = useState(false);

	const enrichRoleData = useCallback((roles) => {
		return roles.map(role => {
			// First check if the role has organisation_name from the API
			if (role.organisation_name) {
				return {
					...role,
					organization_name: role.organisation_name,
					organization_id: role.org_id || role.organization_id
				};
			}
			
			// Then check if it already has an organization_name
			if (role.organization_name && role.organization_name !== 'N/A') {
				return role;
			}
			
			const department = departments.find(dept => dept.id === role.department_id);
			return {
				...role,
				organization_id: role.org_id || department?.organisation_id || department?.organization_id || role.organization_id,
				organization_name: role.organisation_name || department?.organisation_name || department?.organization_name || role.organization_name || 'N/A'
			};
		});
	}, [departments]);

	const fetchData = async () => {
		try {
			// Only set table loading, not full page
			setIsTableLoading(true);

			// Build query parameters based on active filters
			let queryParams = [];
			
			// Add organization_name if selected
			if (filters.organization_id) {
				const selectedOrg = filterOrganizations.find(org => org.id === filters.organization_id);
				if (selectedOrg && selectedOrg.name) {
					queryParams.push(`organisation_name=${encodeURIComponent(selectedOrg.name)}`);
				}
			}
			
			// Add department_name if selected
			if (filters.department_id) {
				const selectedDept = filteredDepartments.find(dept => dept.id === filters.department_id);
				if (selectedDept && selectedDept.name) {
					queryParams.push(`department_name=${encodeURIComponent(selectedDept.name)}`);
				}
			}
			
			// Add subdepartment_name if selected
			if (filters.subdepartment_id) {
				const selectedSubdept = filteredSubDepartments.find(subdept => subdept.id === filters.subdepartment_id);
				if (selectedSubdept && selectedSubdept.name) {
					queryParams.push(`subdepartment_name=${encodeURIComponent(selectedSubdept.name)}`);
				}
			}
			
			// Add role_name if provided
			if (roleSearch) {
				queryParams.push(`role_name=${encodeURIComponent(roleSearch)}`);
			}
			
			// Construct the API URL with query parameters
			let apiUrl = `${apiEndpoints.ROLE}?page=${currentPage}&page_size=${pageSize}`;
			if (queryParams.length > 0) {
				apiUrl += `&${queryParams.join('&')}`;
			}
			
			// Make the API call
			const response = await apiCall("get", apiUrl);
			
			if (response) {
				const roleItems = response.items || [];
				
				// Store the raw data
				setAllRows(roleItems);
				
				// Now enrich with department/organization data
				const enrichedData = enrichRoleData(roleItems);
				setFilteredRows(enrichedData);
				
				setTotalItems(response.total || 0);
				setTotalPages(Math.ceil(response.total / pageSize));
			}
		} catch (error) {
			console.error("Error fetching data:", error);
			setFilteredRows([]);
			setTotalItems(0);
		} finally {
			setIsTableLoading(false); // Reset table loading
			setIsLoading(false); // Also ensure the initial loading is set to false
		}
	};

	// Update the initialization useEffect - fetch department data and role data initially
	useEffect(() => {
		const initializeData = async () => {
			setIsLoading(true);
			try {
				// Try to get organization data in case we need it for enrichment
				
				
				// Then fetch the roles
				await fetchData();
			} catch (error) {
				console.error("Error during initialization:", error);
				setIsLoading(false);
			}
		};
		
		initializeData();

	}, []); // Empty dependency array for initial load only

	// Fix the pagination useEffect to actually fetch new data
	useEffect(() => {
		// Don't fetch during initial loading
		if (!isLoading) {
			setIsTableLoading(true);
			fetchData();
		}
	}, [currentPage, pageSize]);

	// Update the useEffect to handle data changes properly
	useEffect(() => {
		if (departments.length > 0 && allRows.length > 0) {
			// Re-enrich data when departments change
			const enrichedData = enrichRoleData(allRows);
			setFilteredRows(enrichedData);
		}
	}, [departments, enrichRoleData, allRows]);

	const postData = async (obj) => {
		try {
			const data = await apiCall("post", apiEndpoints.ROLE, obj);
			console.log(data);
			toasty("Role Created successfully");
				dispatch(setOpenModal({ modalVisible: false }));
			fetchData(); // Refresh the data after creation
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};
	const putData = async (obj) => {
		try {
			const data = await apiCall("put", apiEndpoints.ROLE, obj);
			console.log(data);
			toasty("Role Updated successfully");
			dispatch(setOpenModal({ modalVisible: false }));
			fetchData(); // Refresh the data after update
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};
	const deleteData = async (id) => {
		try {
			const data = await apiCall("delete", `${apiEndpoints.ROLE}/${id}`);
			console.log(data);
			toasty("Role Deleted successfully");
			fetchData(); // Refresh the data after deletion
		} catch (error) {
			console.error("Error fetching data:", error);
		}
	};
	
	// We'll keep these methods but they'll only be called when needed for filtering
	
	const getSubdepartmentData = async () => {
		try {
			const response = await apiCall("get", apiEndpoints.SUB_DEPARTMENT);
			
			// Check for paginated response format
			if (response?.items && Array.isArray(response.items)) {
				const result = response.items.map((subdepartment) => ({
					id: subdepartment.id,
					name: subdepartment.name,
					department_id: subdepartment.department_id,
				}));
				setSubDepartments(result);
			} else if (response && Array.isArray(response)) {
				// Fallback for non-paginated format
				const result = response.map((subdepartment) => ({
					id: subdepartment.id,
					name: subdepartment.name,
					department_id: subdepartment.department_id,
				}));
				setSubDepartments(result);
			} else {
				console.error("Invalid subdepartment data format:", response);
				setSubDepartments([]);
			}
		} catch (error) {
			console.error("Error fetching subdepartments:", error);
			setSubDepartments([]);
		}
	};

	// New method to fetch organizations for the modal
	const fetchModalOrganizations = async () => {
		try {
			const response = await apiCall("get", `${apiEndpoints.ORGANIZATION_SUMMARY}`);
			
			if (response?.items && Array.isArray(response.items)) {
				setModalOrganizations(response.items);
			} else if (response && Array.isArray(response)) {
				setModalOrganizations(response);
			} else {
				console.error("Invalid organization data format:", response);
				setModalOrganizations([]);
			}
		} catch (error) {
			console.error("Error fetching organizations:", error);
			setModalOrganizations([]);
		}
	};

	// New method to fetch departments for the modal based on selected organization
	const fetchModalDepartments = async (organizationId) => {
		if (!organizationId) {
			setModalDepartments([]);
			return;
		}
		
		try {
			setModalDepartments([]); // Clear current departments
			setIsLoadingDepartments(true); // Set loading state
			const response = await apiCall("get", `${apiEndpoints.DEPARTMENT_SUMMARY}?organisation_id=${organizationId}`);
			
			if (response?.items && Array.isArray(response.items)) {
				setModalDepartments(response.items);
			} else if (response && Array.isArray(response)) {
				setModalDepartments(response);
			} else {
				console.error("Invalid department data format:", response);
				setModalDepartments([]);
			}
		} catch (error) {
			console.error("Error fetching departments:", error);
			setModalDepartments([]);
		} finally {
			setIsLoadingDepartments(false); // Reset loading state
		}
	};

	// New method to fetch subdepartments for the modal based on selected department
	const fetchModalSubDepartments = async (organizationId, departmentId) => {
		if (!departmentId || !organizationId) {
			setModalSubDepartments([]);
			return;
		}
		
		try {
			setModalSubDepartments([]); // Clear current subdepartments
			setIsLoadingSubDepartments(true); // Set loading state
			const response = await apiCall(
				"get", 
				`${apiEndpoints.SUBDEPARTMENT_SUMMARY}?organisation_id=${organizationId}&department_id=${departmentId}`
			);
			
			if (response?.items && Array.isArray(response.items)) {
				setModalSubDepartments(response.items);
			} else if (response && Array.isArray(response)) {
				setModalSubDepartments(response);
			} else {
				console.error("Invalid subdepartment data format:", response);
				setModalSubDepartments([]);
			}
		} catch (error) {
			console.error("Error fetching subdepartments:", error);
			setModalSubDepartments([]);
		} finally {
			setIsLoadingSubDepartments(false); // Reset loading state
		}
	};

	// Fix the handleChangePage function to properly update state
	const handleChangePage = (page, newPageSize) => {
		setIsTableLoading(true); // Set loading state when changing page
		
		// Update page and page size
		setCurrentPage(page);
		if (newPageSize !== pageSize) {
			setPageSize(newPageSize);
		}
		
		// Note: The useEffect watching currentPage and pageSize will handle the data fetching
	};

	const handleInputChange = (e) => {
		const { name, value } = e.target;
		
		// Special handling for organization selection
		if (name === "organization_name" || name === "organization_id") {
			const selectedOrgId = name === "organization_id" ? value : 
				modalOrganizations.find(org => org.name === value)?.id;
			
			// Update both name and ID
			setNewItem(prevItem => ({
				...prevItem,
				organization_id: selectedOrgId,
				organization_name: name === "organization_name" ? value : 
					modalOrganizations.find(org => org.id === value)?.name,
				// Reset dependent fields
				department_id: "",
				department_name: "",
				subdepartment_id: "",
				subdepartment_name: ""
			}));
			
			// Fetch departments for the selected organization
			if (selectedOrgId) {
				fetchModalDepartments(selectedOrgId);
			}
			return;
		}
		
		// Special handling for department selection
		if (name === "department_name" || name === "department_id") {
			const selectedDeptId = name === "department_id" ? value : 
				modalDepartments.find(dept => dept.name === value)?.id;
			
			// Update both name and ID
			setNewItem(prevItem => ({
				...prevItem,
				department_id: selectedDeptId,
				department_name: name === "department_name" ? value : 
					modalDepartments.find(dept => dept.id === value)?.name,
				// Reset dependent fields
				subdepartment_id: "",
				subdepartment_name: ""
			}));
			
			// Fetch subdepartments for the selected department
			if (selectedDeptId && newItem.organization_id) {
				fetchModalSubDepartments(newItem.organization_id, selectedDeptId);
			}
			return;
		}
		
		// Special handling for subdepartment selection
		if (name === "subdepartment_name" || name === "subdepartment_id") {
			const selectedSubDeptId = name === "subdepartment_id" ? value : 
				modalSubDepartments.find(subdept => subdept.name === value)?.id;
			
			// Update both name and ID
			setNewItem(prevItem => ({
				...prevItem,
				subdepartment_id: selectedSubDeptId,
				subdepartment_name: name === "subdepartment_name" ? value : 
					modalSubDepartments.find(subdept => subdept.id === value)?.name
			}));
			return;
		}
		
		// Default handling for other fields
		setNewItem((prevItem) => ({
			...prevItem,
			[name]: value,
		}));
	};

	const handleAddRow = async () => {
		const {
			department_id,
			subdepartment_id,
			role_name,
			level,
			designation,
			salary_min,
			salary_max,
			employment_type,
			work_arrangement,
			total_rounds,
			location_id,
		} = newItem;

		const raw = {
			department_id,
			subdepartment_id,
			role_name,
			level,
			designation,
			salary_min,
			salary_max,
			employment_type,
			work_arrangement,
			total_rounds,
			location_id,
		};

		await postData(raw);
		setNewItem(resetItemState());
	};

	const handleEditRow = (id, event) => {
		if (event) {
			event.preventDefault();
			event.stopPropagation(); // Stop event from bubbling up
		}
		
		// Find the item to edit from filteredRows instead of rows
		const itemToEdit = filteredRows.find((row) => row.id === id);
		
		if (!itemToEdit) {
			console.error('Item not found for editing');
			return;
		}

		// Set the editing index
		setEditingIndex(id);
		
		// Set the newItem with all required fields, properly mapping org_id to organization_id
		setNewItem({
			id: itemToEdit.id,
			organization_id: itemToEdit.org_id || itemToEdit.organization_id,
			organization_name: itemToEdit.organisation_name || itemToEdit.organization_name,
			department_id: itemToEdit.department_id,
			department_name: itemToEdit.department_name,
			subdepartment_id: itemToEdit.subdepartment_id,
			subdepartment_name: itemToEdit.subdepartment_name,
			role_name: itemToEdit.role_name,
			salary_min: itemToEdit.salary_min,
			salary_max: itemToEdit.salary_max,
			level: itemToEdit.level,
			designation: itemToEdit.designation,
			employment_type: itemToEdit.employment_type,
			work_arrangement: itemToEdit.work_arrangement,
			total_rounds: itemToEdit.total_rounds,
			location_id: itemToEdit.location_id,
		});

		// Fetch related data for the form
		fetchModalOrganizations();
		
		// If we have organization data, fetch departments
		if (itemToEdit.org_id || itemToEdit.organization_id) {
			fetchModalDepartments(itemToEdit.org_id || itemToEdit.organization_id);
		}
		
		// If we have department data, fetch subdepartments
		if ((itemToEdit.org_id || itemToEdit.organization_id) && itemToEdit.department_id) {
			fetchModalSubDepartments(itemToEdit.org_id || itemToEdit.organization_id, itemToEdit.department_id);
		}

		// Open the modal
		dispatch(
			setOpenModal({
				modalVisible: true,
				modalType: "EDIT_ROLE",
			})
		);
	};

	const handleSaveRow = async () => {
		// Create a new object with only the required fields for the API
		const updatedItem = {
			id: newItem.id,
			department_id: newItem.department_id,
			subdepartment_id: newItem.subdepartment_id,
			role_name: newItem.role_name,
			salary_min: newItem.salary_min,
			salary_max: newItem.salary_max,
			level: newItem.level,
			designation: newItem.designation,
			employment_type: newItem.employment_type,
			work_arrangement: newItem.work_arrangement,
			total_rounds: newItem.total_rounds,
			location_id: newItem.location_id
		};

		await putData(updatedItem); // Use the updated item for saving
		setEditingIndex(null);
		setNewItem(resetItemState());
	};

	const handleDeleteRow = async (id) => {
		await deleteData(id);
	};

	const handleAddRole = (id) => {
		const itemToEdit = rows.find((row) => row.id === id);
		setEditingIndex(id);
		setNewItem(itemToEdit);
		dispatch(
			setOpenModal({
				modalVisible: true,
				modalType: "ADD_ROLE",
			})
		);
	};

	const handleSelectChange = (e, index) => {
		const updatedRows = [...rows];
		updatedRows[index].status = e.target.value;
		setRows(updatedRows);
	};

	const handleOpenCreateModal = () => {
		setEditingIndex(null);
		setNewItem(resetItemState());
		// Fetch organizations when opening the create modal
		fetchModalOrganizations();
		dispatch(
			setOpenModal({
				modalVisible: true,
				modalType: "EDIT_ROLE",
			})
		);
	};

	const roleDetails = (id, event) => {
		// Only navigate if the click wasn't on an action button
		if (!event.target.closest('button')) {
			navigate(`/round-management/${id}`);
		}
	};

	const handleRemoveQuestion = (roundIndex, questionIndex) => {
		const updatedRounds = [...newItem.rounds];
		updatedRounds[roundIndex].question_bank.splice(questionIndex, 1);
		setNewItem({ ...newItem, rounds: updatedRounds });
	};

	const handleAddQuestion = (roundIndex) => {
		const updatedRounds = [...newItem.rounds];
		updatedRounds[roundIndex].question_bank.push({
			question: "",
			answer: ""
		});
		setNewItem({ ...newItem, rounds: updatedRounds });
	};

	const handleQuestionChange = (roundIndex, questionIndex, field, value) => {
		const updatedRounds = [...newItem.rounds];
		updatedRounds[roundIndex].question_bank[questionIndex][field] = value;
		setNewItem({ ...newItem, rounds: updatedRounds });
	};

	const handleRemoveRound = (index) => {
		const updatedRounds = newItem.rounds.filter((_, i) => i !== index);
		if (updatedRounds.length === 0) {
			updatedRounds.push({
				round_name: "",
				question_bank: [], // Initialize as empty array
				type: "AI",
				objective: "",
			});
		}
		setNewItem({ ...newItem, rounds: updatedRounds });
	};

	const handleRoundChange = (index, field, value) => {
		const updatedRounds = [...newItem.rounds];
		updatedRounds[index] = { ...updatedRounds[index], [field]: value };
		setNewItem({ ...newItem, rounds: updatedRounds });
	};

	const handleAddRound = () => {
		setNewItem({
			...newItem,
			rounds: [
				...newItem.rounds,
				{
					round_name: "",
					question_bank: [], // Initialize as empty array
					type: "AI",
					objective: "",
					prompt: "",
				},
			],
		});
	};

	// Handle department filter change
	const handleFilterDepartmentChange = (event) => {
		const newDepartmentId = event.target.value;
		setFilterDepartment(newDepartmentId);
		setFilterSubDepartment(""); // Reset sub-department when department changes
		applyLocalFilters();
	};

	// Handle sub-department filter change
	const handleFilterSubDepartmentChange = (event) => {
		const newSubDepartmentId = event.target.value;
		setFilterSubDepartment(newSubDepartmentId);
		applyLocalFilters();
	};

	// Apply filter logic based on department and sub-department
	const applyLocalFilters = async () => {
		// Always reset to the first page when filters are applied
		setCurrentPage(1);
		
		// Set loading state for the table only
		setIsTableLoading(true);
		
		try {
			// Build query parameters based on selected filters
			let queryParams = [];
			
			// Add organization_name if selected
			if (tempFilters.organization_id) {
				const selectedOrg = filterOrganizations.find(org => org.id === tempFilters.organization_id);
				if (selectedOrg && selectedOrg.name) {
					queryParams.push(`organisation_name=${encodeURIComponent(selectedOrg.name)}`);
				}
			}
			
			// Add department_name if selected
			if (tempFilters.department_id) {
				const selectedDept = filteredDepartments.find(dept => dept.id === tempFilters.department_id);
				if (selectedDept && selectedDept.name) {
					queryParams.push(`department_name=${encodeURIComponent(selectedDept.name)}`);
				}
			}
			
			// Add subdepartment_name if selected
			if (tempFilters.subdepartment_id) {
				const selectedSubdept = filteredSubDepartments.find(subdept => subdept.id === tempFilters.subdepartment_id);
				if (selectedSubdept && selectedSubdept.name) {
					queryParams.push(`subdepartment_name=${encodeURIComponent(selectedSubdept.name)}`);
				}
			}
			
			// Add role_name if provided
			if (roleSearch) {
				queryParams.push(`role_name=${encodeURIComponent(roleSearch)}`);
			}
			
			// Construct the API URL with query parameters
			let apiUrl = `${apiEndpoints.ROLE}?page=${currentPage}&page_size=${pageSize}`;
			if (queryParams.length > 0) {
				apiUrl += `&${queryParams.join('&')}`;
			}
			
			// Make the API call
			const response = await apiCall("get", apiUrl);
			
			if (response) {
				const roleItems = response.items || [];
				
				// Store the raw data
				setAllRows(roleItems);
				
				// Properly enrich the data with organization information
				const enrichedData = enrichRoleData(roleItems);
				setFilteredRows(enrichedData);
				
				// Update total counts
				setTotalItems(response.total || 0);
				setTotalPages(Math.ceil(response.total / pageSize));
				
				// Show no data modal if necessary
				if (roleItems.length === 0) {
					setNoDataModalOpen(true);
				}
			}
			
			// Update the actual filters from temp filters
			setFilters(tempFilters);
			
			// Close the filter popup after applying filters
			setFilterVisible(false);
		} catch (error) {
			console.error("Error fetching filtered data:", error);
			toasty("Error fetching filtered data", "error");
			setFilteredRows([]);
			setTotalItems(0);
		} finally {
			// Reset table loading state
			setIsTableLoading(false);
		}
	};

	const handleClearFilters = async () => {
		// Reset all filter states
		setTempFilters({
			organization_id: "",
			department_id: "",
			subdepartment_id: ""
		});
		setFilteredDepartments([]);
		setFilteredSubDepartments([]);
		setCurrentPage(1);
		setFilterVisible(false);
		setFilters({
			organization_id: "",
			department_id: "",
			subdepartment_id: ""
		});
		setRoleSearch(""); // Clear role search
		
		setIsTableLoading(true); // Only set table loading
		
		try {
			const response = await apiCall(
				"get", 
				`${apiEndpoints.ROLE}?page=1&page_size=${pageSize}`
			);
			
			if (response) {
				const roleItems = response.items || [];
				
				// Store the raw data
				setAllRows(roleItems);
				
				// Make sure to properly enrich the data with organization info
				const enrichedData = enrichRoleData(roleItems);
				setFilteredRows(enrichedData);
				
				// Update total counts
				setTotalItems(response.total || 0);
				setTotalPages(Math.ceil(response.total / pageSize));
			}
		} catch (error) {
			console.error("Error fetching data after clearing filters:", error);
		} finally {
			setIsTableLoading(false); // Reset table loading
		}
	};

	const handleCloseNoDataModal = () => {
		setNoDataModalOpen(false);
	};

	const addRoleComponent = () => {
		return (
			<ModalManager>
				<AddRoleTableForm
					item={newItem}
					onChange={handleInputChange}
					onSave={editingIndex !== null ? handleSaveRow : handleAddRow}
					onClear={() =>
						setNewItem({
							id: "",
							department_name: "",
							subDepartment_name: "",
							role_name: "",
							rounds: [
								{
									round_name: "",
									question_bank: [],	
									type: "",
									objective: "",
									prompt: "",
								},
							],
						})
					}
					onRoundChange={handleRoundChange}
					onAddRound={handleAddRound}
					onAddQuestion={handleAddQuestion}
					onQuestionChange={handleQuestionChange}
					onRemoveRound={handleRemoveRound}
					onRemoveQuestion={handleRemoveQuestion}
				/>
			</ModalManager>
		);
	};

	
	// Update handleTempFilterChange to handle cascading filters
	const handleTempFilterChange = (filterType, value) => {
		console.log(`Changing ${filterType} filter to:`, value); // Debug log
		
		setTempFilters(prev => {
			const newFilters = { ...prev };
			
			switch(filterType) {
				case 'organization':
					if (prev.organization_id === value) {
						newFilters.organization_id = "";
						newFilters.department_id = "";
						newFilters.subdepartment_id = "";
						setFilteredDepartments([]);
						setFilteredSubDepartments([]);
					} else {
						newFilters.organization_id = value;
						newFilters.department_id = "";
						newFilters.subdepartment_id = "";
						
						// Fetch departments for the selected organization
						fetchFilterDepartments(value);
					}
					break;

				case 'department':
					if (prev.department_id === value) {
						newFilters.department_id = "";
						newFilters.subdepartment_id = "";
						setFilteredSubDepartments([]);
					} else {
						newFilters.department_id = value;
						newFilters.subdepartment_id = "";
						
						// Fetch subdepartments for the selected department
						if (prev.organization_id) {
							fetchFilterSubDepartments(prev.organization_id, value);
						}
					}
					break;

				case 'subdepartment':
					newFilters.subdepartment_id = prev.subdepartment_id === value ? "" : value;
					break;

				default:
					break;
			}
			
			return newFilters;
		});
	};

	// When filter button is clicked, fetch organizations for filtering
	useEffect(() => {
		if (filterVisible && filterOrganizations.length === 0) {
			fetchFilterOrganizations();
		}
	}, [filterVisible]);

	// Update fetchOrganizations to fetch only filter organizations
	const fetchFilterOrganizations = async () => {
		try {
			setIsLoadingFilterOrgs(true);
			const response = await apiCall("get", `${apiEndpoints.ORGANIZATION_SUMMARY}`);
			
			if (response?.items && Array.isArray(response.items)) {
				setFilterOrganizations(response.items);
			} else if (response && Array.isArray(response)) {
				setFilterOrganizations(response);
			} else {
				console.error("Invalid organization data format:", response);
				setFilterOrganizations([]);
			}
		} catch (error) {
			console.error("Error fetching filter organizations:", error);
			setFilterOrganizations([]);
		} finally {
			setIsLoadingFilterOrgs(false);
		}
	};

	// Add function to fetch departments for a specific organization in the filter
	const fetchFilterDepartments = async (organizationId) => {
		if (!organizationId) {
			setFilteredDepartments([]);
			return;
		}
		
		try {
			setIsLoadingFilterDepts(true);
			const response = await apiCall("get", `${apiEndpoints.DEPARTMENT_SUMMARY}?organisation_id=${organizationId}`);
			
			if (response?.items && Array.isArray(response.items)) {
				setFilteredDepartments(response.items);
			} else if (response && Array.isArray(response)) {
				setFilteredDepartments(response);
			} else {
				console.error("Invalid department data format:", response);
				setFilteredDepartments([]);
			}
		} catch (error) {
			console.error("Error fetching filter departments:", error);
			setFilteredDepartments([]);
		} finally {
			setIsLoadingFilterDepts(false);
		}
	};

	// Add function to fetch subdepartments for a specific department in the filter
	const fetchFilterSubDepartments = async (organizationId, departmentId) => {
		if (!departmentId || !organizationId) {
			setFilteredSubDepartments([]);
			return;
		}
		
		try {
			setIsLoadingFilterSubDepts(true);
			const response = await apiCall(
				"get", 
				`${apiEndpoints.SUBDEPARTMENT_SUMMARY}?organisation_id=${organizationId}&department_id=${departmentId}`
			);
			
			if (response?.items && Array.isArray(response.items)) {
				setFilteredSubDepartments(response.items);
			} else if (response && Array.isArray(response)) {
				setFilteredSubDepartments(response);
			} else {
				console.error("Invalid subdepartment data format:", response);
				setFilteredSubDepartments([]);
			}
		} catch (error) {
			console.error("Error fetching filter subdepartments:", error);
			setFilteredSubDepartments([]);
		} finally {
			setIsLoadingFilterSubDepts(false);
		}
	};

	return (
		<div className={styles.container}>
			<div className={styles.buttonContainer} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', marginBottom: '20px' }}>
				<span style={{ fontFamily: "Inter", fontSize: "16px",marginLeft: "20px" }}>List of Role</span>
				<div style={{ display: 'flex', gap: '12px', alignItems: 'center' }}>
					<img 
						src={filterIcon}
						onClick={() => setFilterVisible(true)}
						alt="filter"
						style={{ 
							width: "155px",
							height: "32px",
							objectFit: "contain",
							cursor: "pointer",
							transition: "transform 0.2s",
							position: "relative",
							marginRight: "-40px"
						}}
						onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
						onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
						onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
					/>
					{(filterDepartment || filterSubDepartment) && (
						<span 
							style={{
								position: "absolute",
								width: "8px",
								height: "8px",
								borderRadius: "50%",
								backgroundColor: "#2563EB",
								right: "45px",
								top: "25px"
							}}
						/>
					)}

					<img 
						style={{
							cursor: 'pointer',
							width: '155px',
							height: '32px',
							padding: '2px 10px 2px 8px',
							gap: '6px',
							borderRadius: '6px',
						}} 
						onClick={handleOpenCreateModal} 
						src={CreateRole}
					/>
				</div>
			</div>

			{modalVisible && modalType === "ADD_ROLE" ? (
				addRoleComponent()
			) : modalVisible && modalType === "EDIT_ROLE" ? (
				<ModalManager customWidth={window.innerWidth/300}>
					<TableForm
						item={newItem}
						organizations={modalOrganizations}
						departments={modalDepartments}
						subDepartments={modalSubDepartments}
						onChange={handleInputChange}
						onSave={editingIndex !== null ? handleSaveRow : handleAddRow}
						onClear={() => setNewItem(resetItemState())}
						isEdit={editingIndex !== null}
						isLoadingDepartments={isLoadingDepartments}
						isLoadingSubDepartments={isLoadingSubDepartments}
					/>
				</ModalManager>
			) : null}
			
			{isLoading ? (
				<div style={{ display: 'flex', justifyContent: 'center', alignItems: 'center', height: '60vh' }}>
					{/* <Spin size="large" /> */}
				</div>
			) : (
				<div style={{ position: 'relative' }}>
					{isTableLoading && !isLoading && (
						<div style={{ 
							position: 'absolute',
							top: 0,
							left: 0,
							right: 0,
							bottom: 0,
							backgroundColor: 'rgba(255, 255, 255, 0.7)',
							display: 'flex',
							justifyContent: 'center',
							alignItems: 'center',
							zIndex: 10
						}}>
							{/* <Spin size="large" /> */}
						</div>
					)}
					<DataTable
						rows={filteredRows}
						page={currentPage}
						totalItems={totalItems}
						handleChangePage={handleChangePage}
						handleEditRow={handleEditRow}
						handleDeleteRow={handleDeleteRow}
						roleDetails={roleDetails}
					/>
				</div>
			)}

			<Dialog open={noDataModalOpen} onClose={handleCloseNoDataModal}>
				<DialogTitle>No Data Available</DialogTitle>
				<DialogContent>
					<p>There is no data available for the selected filters.</p>
				</DialogContent>
				<DialogActions>
					<Button onClick={handleCloseNoDataModal} color="primary">
						Close
					</Button>
				</DialogActions>
			</Dialog>

			{filterVisible && (
				<div 
					ref={filterRef}
					style={{
						position: 'fixed',
						right: '24px',
						top: '50%',
						transform: 'translateY(-50%)',
						zIndex: 1000,
						width: "410px",
						backgroundColor: "#FFFFFF",
						borderRadius: "8px",
						boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.15)",
						display: "flex",
						flexDirection: "column",
						maxHeight: "80vh",
						overflowY: "auto"
					}}>
					{/* Header */}
					<div style={{
						display: "flex",
						justifyContent: "space-between",
						alignItems: "center",
						padding: "16px",
						background: "rgba(247, 247, 248, 1)",
						borderBottom: "1px solid rgba(229, 231, 235, 1)",
						fontFamily: "Inter",
						position: "sticky",
						top: 0,
						zIndex: 1000
					}}>
						<div style={{ 
							display: "flex", 
							alignItems: "center", 
							gap: "8px",
							fontSize: "14px",
							fontWeight: "500",
							color: "#27272A"
						}}>
							
							<svg xmlns="http://www.w3.org/2000/svg" xmlnsXlink="http://www.w3.org/1999/xlink" width="18" height="18" viewBox="54 54">
											<image xlinkHref="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAADYAAAA2CAYAAACMRWrdAAACEUlEQVRoQ+2YPU4CQRiGZ3ahMdFAIv50FECwwxvICfQIStaEEk8AnkBsjFGCegNuAJ5AShQLChNjgEhiQaIw424hQVhhZtgPRvJtQsN+f+/7zGZnlpIlveiS6iIo7L+RRWJITBMHcClqAkJ4DCQmbJUmga7EoqnWIadk3359BzSZ888xKCN39eL67WjAmLC41dzrc1LWXdDwfKa/l6xdbleG/xsTFrPecpwb2f8kjFJ2+lTYzE0UFk/bxL6WkJij2nnGCOH2T+/LMFiHMbMk9IzpLUV8OnyPiXulRyQS04OD+BRITNwrPSKRmBuH6PFLwuQm2Ea5Vvi9/5NZC0rEEunXcPfTLDNKwzLNZGMp542VNf9uNR/sSOfKJgy2XJTfqOTK5nDaP3kubOVl85SIRax2hnJ2JttMKZ7TI7e94LRaSsISmfdA94M9MMJglyIxGsaqkazlg41pQkbvKwn7KeIccWQbisb3DV+nfhGsisZ7Kky16TzyZiI2jwFVe6AwVecWlYfEFuW8al8kpurcovJAiEVS7SwxuNDL26Ss9Hi9ce61AZ4LU9lHun3JnVUogLBW2T5uCNEaDM/Jfb0YksuZotxzYTGraX/7J1Lf/lWPJpO0eS7MabZjH2t6jB2ILCfTRyq1q1BOJFYmBkSYzABQsSgMylmoukgMylmoukgMylmoukgMylmoukgMylmout/YToI3olh5xwAAAABJRU5ErkJggg==" x="0" y="0" width="14" height="14"/>
										</svg>
							<span>Filters</span>
						</div>
						<CloseOutlined 
							style={{ fontSize: "16px", cursor: "pointer", color: "#6B7280" }} 
							onClick={() => setFilterVisible(false)}
						/>
					</div>

					{/* Filter Content */}
					<div style={{ padding: "16px", flexGrow: 1, fontFamily: "Inter" }}>
						{/* Organization Section */}
						<div style={{ marginBottom: "24px" }}>
							<div style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: "12px"
							}}>
								<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
									<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M10.4965 4.90039H6.29648C5.52438 4.90039 4.89648 5.52829 4.89648 6.30039V11.9004H11.8965V6.30039C11.8965 5.52829 11.2686 4.90039 10.4965 4.90039Z" fill="#2563EB"/>
										<path d="M2.79883 11.9003V3.32812C2.79883 3.01592 3.00603 2.74082 3.30633 2.65472L6.80633 1.65442C7.25363 1.52632 7.69883 1.86232 7.69883 2.32782V3.49962" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
										<path d="M2.09766 11.9004H11.8977" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
									<span style={{ fontSize: "16px" }}>By Organisation</span>
								</div>
								<span style={{ color: "#6B7280", fontSize: "14px"  }}>
									({tempFilters.organization_id ? "1" : "0"} selected)
								</span>
							</div>
							<div style={{ 
								display: "flex", 
								flexDirection: "column", 
								gap: "8px",
								maxHeight: "150px",
								overflowY: "auto",
								padding: "4px"
							}}>
								{isLoadingFilterOrgs ? (
									<div style={{ padding: "12px", textAlign: "center" }}>
										<Spin size="small" />
									</div>
								) : (
									filterOrganizations.map((org) => (
										<div 
											key={org.id}
											style={{
												display: "flex",
												alignItems: "center",
												gap: "8px",
												padding: "8px",
												cursor: "pointer",
												borderRadius: "6px",
												backgroundColor: tempFilters.organization_id === org.id ? "#F3F4F6" : "transparent"
											}}
											onClick={(e) => {
												// Only trigger if the click wasn't on the checkbox
												if (!e.target.closest('input[type="checkbox"]')) {
													handleTempFilterChange('organization', org.id);
												}
											}}
										>
											<input 
												type="checkbox" 
												checked={tempFilters.organization_id === org.id}
												onChange={(e) => {
													e.stopPropagation();
													handleTempFilterChange('organization', org.id);
												}}
												style={{ 
													width: "14px",
													height: "14px",
													top: "3px",
													left: "3px",
													gap: "0px",
													borderRadius: "3px",
													border: "1px solid rgba(255, 255, 255, 1)",
													background: "rgba(238, 238, 240, 1)",
													boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.12)",
													cursor: "pointer"
												}}
											/>
											<span>{org.name}</span>
										</div>
									))
								)}
							</div>
						</div>
						<div style={{ width: "368px", height: "1px", backgroundColor: "#E5E7EB", margin: "8px 0" }} />

						{/* Department Section */}
						<div style={{ marginBottom: "24px" }}>
							<div style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: "12px"
							}}>
								<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
									<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M7.00156 4.19961H2.10156V3.14961C2.10156 2.57001 2.57196 2.09961 3.15156 2.09961H5.22706C5.46086 2.09961 5.67996 2.21651 5.80946 2.41111L7.00156 4.19961Z" fill="#2563EB"/>
										<path d="M2.10156 4.19971H10.8516C11.4312 4.19971 11.9016 4.67011 11.9016 5.24971V9.79971C11.9016 10.9589 10.9608 11.8997 9.80156 11.8997H4.20156C3.04236 11.8997 2.10156 10.9589 2.10156 9.79971V4.19971Z" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
									<span style={{ fontSize: "16px" }}>By Department</span>
								</div>
								<span style={{ color: "#6B7280", fontSize: "14px" }}>
									({tempFilters.department_id ? "1" : "0"} selected)
								</span>
							</div>
							<div style={{ 
								display: "flex", 
								flexDirection: "column", 
								gap: "8px",
								maxHeight: "150px",
								overflowY: "auto",
								padding: "4px"
							}}>
								{!tempFilters.organization_id ? (
									<div style={{ padding: "8px", color: "#6B7280" }}>
										Please select an organization first
									</div>
								) : isLoadingFilterDepts ? (
									<div style={{ padding: "12px", textAlign: "center" }}>
										<Spin size="small" />
									</div>
								) : (
									filteredDepartments.map((dept) => (
										<div 
											key={dept.id}
											style={{
												display: "flex",
												alignItems: "center",
												gap: "8px",
												padding: "8px",
												cursor: "pointer",
												borderRadius: "6px",
												backgroundColor: tempFilters.department_id === dept.id ? "#F3F4F6" : "transparent"
											}}
											onClick={(e) => {
												// Only trigger if the click wasn't on the checkbox
												if (!e.target.closest('input[type="checkbox"]')) {
													handleTempFilterChange('department', dept.id);
												}
											}}
										>
											<input 
												type="checkbox" 
												checked={tempFilters.department_id === dept.id}
												onChange={(e) => {
													e.stopPropagation();
													handleTempFilterChange('department', dept.id);
												}}
												style={{ 
													width: "14px",
													height: "14px",
													top: "3px",
													left: "3px",
													gap: "0px",
													borderRadius: "3px",
													border: "1px solid rgba(255, 255, 255, 1)",
													background: "rgba(238, 238, 240, 1)",
													boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.12)",
													cursor: "pointer"
												}}
											/>
											<span>{dept.name}</span>
										</div>
									))
								)}
							</div>
						</div>
						<div style={{ width: "368px", height: "1px", backgroundColor: "#E5E7EB", margin: "8px 0" }} />

						{/* Sub-department Section */}
						<div style={{ marginBottom: "24px" }}>
							<div style={{
								display: "flex",
								justifyContent: "space-between",
								alignItems: "center",
								marginBottom: "12px"
							}}>
								<div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
									<svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg">
										<path d="M9.45156 4.19961H7.00156L5.80946 2.41111C5.67996 2.21651 5.46086 2.09961 5.22706 2.09961H3.15156C2.57196 2.09961 2.10156 2.57001 2.10156 3.14961V9.79961C2.10156 10.3463 2.31086 10.8433 2.65386 11.2171C2.47606 10.9231 2.39836 10.5654 2.48026 10.1958L3.25796 6.69581C3.40006 6.05531 3.96846 5.59961 4.62436 5.59961H10.5016V5.24961C10.5016 4.67001 10.0312 4.19961 9.45156 4.19961Z" fill="#2563EB"/>
										<path d="M9.83125 11.8996H3.84765C2.95235 11.8996 2.28665 11.0701 2.48125 10.1958L3.25895 6.69581C3.40105 6.05531 3.96945 5.59961 4.62535 5.59961H10.609C11.5043 5.59961 12.17 6.42911 11.9754 7.30341L11.1977 10.8034C11.0556 11.4439 10.4872 11.8996 9.83125 11.8996Z" stroke="#2563EB" strokeWidth="1.25" strokeLinecap="round" strokeLinejoin="round"/>
									</svg>
									<span style={{ fontSize: "16px" }}>By SubDepartment</span>
								</div>
								<span style={{ color: "#6B7280", fontSize: "14px" }}>
									({tempFilters.subdepartment_id ? "1" : "0"} selected)
								</span>
							</div>
							<div style={{ 
								display: "flex", 
								flexDirection: "column", 
								gap: "8px",
								maxHeight: "150px",
								overflowY: "auto",
								padding: "4px"
							}}>
								{!tempFilters.department_id ? (
									<div style={{ padding: "8px", color: "#6B7280" }}>
										Please select a department first
									</div>
								) : isLoadingFilterSubDepts ? (
									<div style={{ padding: "12px", textAlign: "center" }}>
										<Spin size="small" />
									</div>
								) : (
									filteredSubDepartments.map((subdept) => (
										<div 
											key={subdept.id}
											style={{
												display: "flex",
												alignItems: "center",
												gap: "8px",
												padding: "8px",
												cursor: "pointer",
												borderRadius: "6px",
												backgroundColor: tempFilters.subdepartment_id === subdept.id ? "#F3F4F6" : "transparent"
											}}
											onClick={(e) => {
												// Only trigger if the click wasn't on the checkbox
												if (!e.target.closest('input[type="checkbox"]')) {
													handleTempFilterChange('subdepartment', subdept.id);
												}
											}}
										>
											<input 
												type="checkbox" 
												checked={tempFilters.subdepartment_id === subdept.id}
												onChange={(e) => {
													e.stopPropagation();
													handleTempFilterChange('subdepartment', subdept.id);
												}}
												style={{ 
													width: "14px",
													height: "14px",
													top: "3px",
													left: "3px",
													gap: "0px",
													borderRadius: "3px",
													border: "1px solid rgba(255, 255, 255, 1)",
													background: "rgba(238, 238, 240, 1)",
													boxShadow: "0px 1px 2px 0px rgba(0, 0, 0, 0.12)",
													cursor: "pointer"
												}}
											/>
											<span>{subdept.name}</span>
										</div>
									))
								)}
							</div>
						</div>
					</div>

					{/* Footer */}
					<div style={{ 
						padding: "16px",
						display: "flex",
						gap: "10px",
						background: "rgba(238, 238, 240, 1)",
						borderTop: "0.5px solid rgba(218, 218, 221, 1)",
						borderRadius: '8px 8px',
						position: "sticky",
						bottom: 0,
						left: 0,
						right: 0,
						fontFamily: "Inter"
					}}>
						<img 
							src={cancelIcon} 
							onClick={handleClearFilters}
							alt="cancel" 
							style={{ 
								width: "180px",
								height: "48px",
								objectFit: "contain",
								cursor: "pointer",
								transition: "transform 0.2s",
								marginBottom: "-5px"
							}}
							onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
							onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
							onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
						/>
						
						<img 
							src={saveIcon} 
							onClick={applyLocalFilters}
							alt="save" 
							style={{ 
								width: "180px",
								height: "40px",
								objectFit: "contain",
								cursor: "pointer",
								transition: "transform 0.2s"
							}}
							onMouseDown={(e) => e.currentTarget.style.transform = "scale(0.95)"}
							onMouseUp={(e) => e.currentTarget.style.transform = "scale(1)"}
							onMouseLeave={(e) => e.currentTarget.style.transform = "scale(1)"}
						/>
					</div>
				</div>
			)}

			
		</div>
	);
};

export default RoleManagement;